import api from './api';

const g = (url, params) => api.get(`/api/ato${url}`, { params }).then((r) => r.data);
const p = (url, body, params) => api.post(`/api/ato${url}`, body, { params }).then((r) => r.data);

export const atoAPI = {
  access: () => g('/access'),
  registry: () => g('/registry'),
  dashboard: (params) => g('/dashboard', params),
  correspondence: (params) => g('/correspondence', params),
  getCorrespondence: (id) => g(`/correspondence/${id}`),
  action: (id, body) => p(`/correspondence/${id}/action`, body),
  documentBlob: (id) => api.get(`/api/ato/correspondence/${id}/document`, { responseType: 'blob' }).then((r) => r.data),
  accounts: (params) => g('/accounts', params),
  lodgments: (params) => g('/lodgments', params),
  linkTask: (id, body = {}) => p(`/lodgments/${id}/link-task`, body),
  asReports: (params) => g('/as-reports', params),
  asCsv: (params) => api.get('/api/ato/as-reports/export.csv', { params, responseType: 'blob' }).then((r) => r.data),
  asTask: (id) => p(`/as-reports/${id}/create-task`),
  clientDetails: (params) => g('/client-details', params),
  decide: (id, accept) => p(`/client-details/${id}/decide`, { accept }),
  rules: () => g('/rules'),
  saveRules: (rules) => api.put('/api/ato/rules', { rules }).then((r) => r.data),
  runRules: () => p('/rules/run'),
  sync: (client_id) => p('/sync', null, client_id ? { client_id } : undefined),
  jobs: (params) => g('/sync/jobs', params),
  retry: (id) => p(`/sync/errors/${id}/retry`),
  settings: () => g('/settings'),
  saveSettings: (body) => api.put('/api/ato/settings', body).then((r) => r.data),
  loadSynthetic: () => p('/synthetic/load'),
  removeSynthetic: () => p('/synthetic/remove'),
  clientOverview: (id) => g(`/clients/${id}/overview`),
};

export const errMsg = (e) => e?.response?.data?.detail || e?.message || 'Something went wrong';

export const STATE_TONE = {
  REVIEW_REQUIRED: 'bg-amber-100 text-amber-900 border-amber-200',
  APPROVED: 'bg-sky-100 text-sky-900 border-sky-200',
  DELIVERED: 'bg-emerald-100 text-emerald-900 border-emerald-200',
  COMPLETED: 'bg-muted text-muted-foreground border-border',
  ARCHIVED: 'bg-muted text-muted-foreground border-border',
  UNMATCHED: 'bg-rose-100 text-rose-900 border-rose-200',
  SECURITY_HOLD: 'bg-rose-200 text-rose-950 border-rose-300',
  FETCH_FAILED: 'bg-rose-100 text-rose-900 border-rose-200',
  REQUIRES_MANUAL_REVIEW: 'bg-orange-100 text-orange-900 border-orange-200',
};

export const money = (v) => (v == null ? '—' : Number(v).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }));
